import { httpClient } from '@/shared/services/HttpClient';

class EstateAgencyService {
  url = 'operation/estateagency';

  getById(estateAgencyId: number): any {
    return httpClient.get(this.url + '/' + estateAgencyId);
  }

  getDescription(estateAgencyId: number, params?: any): any {
    return httpClient.get(this.url + '/' + estateAgencyId + '/description', { params });
  }

  getByUrlName(urlName: string): any {
    return httpClient.get(this.url + '/name/' + urlName);
  }

  register(data: any): any {
    return httpClient.post(this.url + '/register', data);
  }

  checkIdNumber(data: any): any {
    return httpClient.post(this.url + '/idnumber', data);
  }

  getProfile(): any {
    return httpClient.get(this.url + '/profile');
  }

  updateProfile(data: any): any {
    return httpClient.put(this.url + '/profile', data);
  }

  uploadLogo(formData: any, onUploadProgress: any): any {
    return httpClient.post(this.url + '/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: onUploadProgress,
    });
  }

  getEstateAgents(estateAgencyId: number): any {
    return httpClient.get(this.url + '/estateagent', { params: { estateAgencyId, pageSize: 1000, sortby: 'lastName' } });
  }

  getProfileEstateAgents(): any {
    return httpClient.get(this.url + '/profile/estateagent', { params: { pageSize: 1000, sortby: 'lastName' } });
  }
}

const estateAgencyService = new EstateAgencyService();

export { estateAgencyService };
